import React from 'react';
import { useTranslation } from 'react-i18next';
import Abdelhamid from '../../Assets/Bensalah abdelhamid.jpg';
import Idir from '../../Assets/Idir belmokhtar.jpg';
import Abdallah from '../../Assets/Abdallah Benassloun.jpg';
import Zakaria from '../../Assets/Zakaria Oukil.jpg';
import abdennour from '../../Assets/Abdenour hachrouf.jpg';
import AitAhmed from '../../Assets/AietHmed.png';
import Houssam from '../../Assets/Housam bouzidi.jpg'


function LeadershipSection() {
  const { t,i18n } = useTranslation();
  const leaders = t('LeadershipSection.team', { returnObjects: true });

  // Image mapping based on names
  const images = {
    "Abdelhamid Bensalah": Abdelhamid,
    "Houssam Bouzidi": Houssam,
    "Idir Belmokhtar": Idir,
    "Oukil Zakarya": Zakaria,
    "Abdallah Benassloune": Abdallah,
    "Saoussene Ait Ahmed": AitAhmed,
    "عبدالحميد بن صالح" : Abdelhamid,
    "حسام بوزيدي" : Houssam,
    "إيدير بلمختار" :Idir , 
    "زكريا أوكيل" : Zakaria,
    "عبدالله بن عسلون" : Abdallah,
    "سوسن آيت أحمد" :AitAhmed 
  };
  const CircularJSON = require('circular-json');
  console.log(CircularJSON.stringify(images));
  return (
    <div id='OurTeam' className="py-20 dark:bg-Eerie-Black">
      <div className="xl:container mx-auto px-6 md:px-12">
        <div className={`${i18n.language === 'ar' ? "text-right" : "text-left"} mb-16 md:w-2/3 lg:w-1/2 text-left`}>
          <h2 className="mb-4 text-2xl font-bold text-gray-800 dark:text-white md:text-4xl">
            {t('LeadershipSection.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-300">
            {t('LeadershipSection.description')}
          </p>
        </div>
        <div className="grid gap-6 px-4 sm:px-0 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {leaders.map((leader, index) => (
            <div key={index} className="group relative rounded-3xl space-y-6 overflow-hidden">
              <img
                className="mx-auto h-[26rem] w-full grayscale object-cover object-top transition duration-500 group-hover:scale-105 group-hover:grayscale-0"
                src={images[leader.name]}
                alt={leader.name}
                loading="lazy"
              />
              <div className="absolute bottom-0 inset-x-0 h-max mt-auto px-8 py-6 bg-Ripe-mango translate-y-72 transition duration-300 ease-in-out group-hover:translate-y-0">
                <div>
                  <h4 className="text-xl font-semibold text-white">{leader.name}</h4>
                  <span className="block text-sm text-gray-100">{leader.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LeadershipSection;
